<div class="rask-cards">
    <ng-content></ng-content>
</div>
